import React from 'react';
import { motion } from 'framer-motion';
import { DonateModule } from './DonateModule';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 overflow-hidden" data-id="element-105" data-mp="ej4lxsz4c3dc">
      <div className="absolute inset-0 z-0" data-id="element-106" data-mp="9luzmm7107tq">
        <img src="https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Arizona desert landscape" className="w-full h-full object-cover object-center" data-id="element-107" data-mp="9igvp9iprqk6" />
        <div className="absolute inset-0 bg-gradient-to-r from-pac-navy/95 via-pac-navy/80 to-pac-navy/40 mix-blend-multiply" data-id="element-108" data-mp="xbfm3f2e1n7r" />
        <div className="absolute inset-0 bg-pac-navy/40" data-id="element-109" data-mp="s9gic42qkoaa" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-110" data-mp="nb6n5th0hnoo">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-111" data-mp="3d1sbczku5nu6">
          <div className="lg:col-span-7 text-white" data-id="element-112" data-mp="382p4d9lap7jk">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-113" data-mp="3814bdoempwnt">
              <div className="inline-block bg-pac-gold text-pac-navy font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-6" data-id="element-114" data-mp="39a35ovdc75ko">
                Arizona's Local Voice
              </div>
              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6 drop-shadow-lg" data-id="element-115" data-mp="30gq6jbooj7q5">
                Defending <span className="text-pac-gold" data-id="element-116" data-mp="2qjv9kx821fdz">Local Control</span>{' '}
                Across Arizona.
              </h1>
              <p className="text-xl sm:text-2xl text-slate-200 mb-8 max-w-2xl font-light leading-relaxed drop-shadow-md" data-id="element-117" data-mp="2viermmjj2712">
                AZ City PAC unites municipal leaders, business leaders, and
                community advocates to build strong cities, safe neighborhoods,
                and thriving communities.
              </p>
              <a href="#mission" className="inline-flex bg-transparent border-2 border-white text-white hover:bg-white hover:text-pac-navy px-8 py-4 rounded font-bold uppercase tracking-wider transition-all" data-id="element-118" data-mp="s3mfk97g6b1j">
                Read Our Mission
              </a>
            </motion.div>
          </div>

          <div className="lg:col-span-5" data-id="element-119" data-mp="1b0nilohfy12u">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-120" data-mp="1b0drtyoknpw3">
              <DonateModule data-id="element-121" data-mp="x3h62bnb8ym2" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}